import { useCallback } from "react"
import { GetApp } from "../../App"
import { useEditState } from "../../App/useEditState"
import { Block } from "../../Components/Block"
import { EditGroup, EditGroupData } from "../../Components/EditGroup"
import { Overlay, OverlayTitle } from "../../Components/Overlay"
import { useOverlayScroll } from "../../Components/useOverlayScroll"
import { OverlayScrollFooter } from "../../Components/OverlayScrollFooter"
import { IShipSettings } from "../../Types"
import { LightsReminderSettingView } from "../ShipSettings/LightsReminderSettingView"
import { OverlayViewDefinition } from "../OverlayView"
import { UserAdviceViewProps } from "./Params"

interface UserAdviceLightsReminderViewProps extends UserAdviceViewProps {
  settings: IShipSettings;
  save: (settings: IShipSettings) => Promise<void>;
}

const editableFields = [
  { name: "lightsReminder", type: "bool" as const },
  { name: "lightsReminderSettings", type: "object" as const, fields: [
    { name: "sailingLights", type: "int" as const, default: null },
    { name: "lead", type: "int" as const, default: null },
    { name: "disabledSignals", type: "int" as const, array: true, default: null },
  ] },
];

export function UserAdviceLightsReminderView({ settings, save, state }: UserAdviceLightsReminderViewProps) {
  const app = GetApp();
  const t = app.getT("UserAdviceLightsReminderView");
  const [edited, onEdited, resetEdited] = useEditState();
  const { bodyRef, showScrollButton, isAtBottom, handleScrollMore } = useOverlayScroll();

  const onSave = useCallback(async (_data: FormData, values: EditGroupData) => {
    await save({ ...settings, ...values });
    resetEdited();
  }, [resetEdited, save, settings]);

  return (
    <div className="UserAdviceLightsReminderView">
      <Overlay closeCallback={() => state.setSelected(undefined)} className="overlay-max-height">
        <OverlayTitle closeCallback={() => state.setSelected(undefined)} title={t("title")} />
        <div ref={bodyRef} className="Overlay-body">
          <EditGroup changed={edited} editable={true} editableFields={editableFields} onSave={onSave}>
            <Block className="">
              <LightsReminderSettingView settings={settings} onEdited={onEdited} />
            </Block>
          </EditGroup>
        </div>
        <OverlayScrollFooter isAtBottom={isAtBottom} showScrollButton={showScrollButton} handleScrollMore={handleScrollMore} readMoreLabel={t("read_more")} />
      </Overlay>
    </div>
  );
}

export function userAdviceLightsReminderOverlay(props: UserAdviceLightsReminderViewProps): OverlayViewDefinition {
  return { render: () => <UserAdviceLightsReminderView {...props} /> };
}
